module.exports = "../../app/cells/pages/bifrost/study_guide/header_cell.rb";